document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.custom-header');
  const panel = document.getElementById('drawerMenu');
  const toggles = document.querySelectorAll('.js-menu-toggle');

  if (!header || !panel || !toggles.length) return;

  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

  const openMenu = () => {
    // Avisa o carrinho para se fechar: os dois paineis nunca ficam juntos.
    document.dispatchEvent(new CustomEvent('hogo:menu:open'));

    panel.classList.add('open');
    header.classList.add('menu-is-open');
    toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));

    // No desktop o painel tem 328px e a pagina continua navegavel por tras.
    if (isMobile()) document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    panel.classList.remove('open');
    header.classList.remove('menu-is-open');
    toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));

    // O carrinho pode estar aberto: so libera a rolagem se ninguem mais precisar.
    if (!header.classList.contains('cart-is-open')) document.body.style.overflow = '';
  };

  document.addEventListener('hogo:cart:open', closeMenu);

  const isOpen = () => header.classList.contains('menu-is-open');

  toggles.forEach((btn) => {
    btn.addEventListener('click', () => (isOpen() ? closeMenu() : openMenu()));
  });

  document.querySelectorAll('.js-menu-close').forEach((el) => {
    el.addEventListener('click', closeMenu);
  });

  panel.addEventListener('click', (e) => {
    if (e.target.closest('a')) closeMenu();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) {
      closeMenu();
      toggles[toggles.length - 1].focus();
    }
  });

  document.addEventListener('click', (e) => {
    if (!isOpen()) return;
    if (e.target.closest('.custom-header')) return;
    closeMenu();
  });

  // Fecha so quando a largura muda de fato (troca de breakpoint, rotacao).
  // No celular, esconder a barra de endereco dispara resize com a mesma
  // largura, e o menu fechava sozinho na cara do cliente.
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    if (isOpen()) closeMenu();
  });
});
